module.exports = __webpack_public_path__ + "img/black_man_profile.1d3ac6ee.png";